/* ============================================================
   LOYWIS - Collection Page JS
   Matches all interactive behaviour from laywis-collections.html
   ============================================================ */
(function () {
  'use strict';

  /* ── View Toggle ──────────────────────────────────────────── */
  var GRID_KEY = 'lw_grid_view';

  function initViewToggle() {
    var grid   = document.getElementById('lwProductsGrid');
    var btn3   = document.getElementById('lwView3');
    var btn4   = document.getElementById('lwView4');
    var btnList = document.getElementById('lwViewList');
    if (!grid || !btn3) return;

    function setView(view) {
      grid.classList.remove('lw-products-grid--4col', 'lw-products-grid--list');
      if (view === '4col') grid.classList.add('lw-products-grid--4col');
      if (view === 'list') grid.classList.add('lw-products-grid--list');
      [btn3, btn4, btnList].forEach(function (b) { if (b) b.classList.remove('lw-vt-btn--active'); });
      if (view === '3col'  && btn3)    btn3.classList.add('lw-vt-btn--active');
      if (view === '4col'  && btn4)    btn4.classList.add('lw-vt-btn--active');
      if (view === 'list'  && btnList) btnList.classList.add('lw-vt-btn--active');
      try { localStorage.setItem(GRID_KEY, view); } catch (_) {}
    }

    var saved = '3col';
    try { saved = localStorage.getItem(GRID_KEY) || '3col'; } catch (_) {}
    setView(saved);

    btn3    && btn3.addEventListener('click',    function () { setView('3col'); });
    btn4    && btn4.addEventListener('click',    function () { setView('4col'); });
    btnList && btnList.addEventListener('click', function () { setView('list'); });
  }

  /* ── Mobile Filter Drawer ─────────────────────────────────── */
  function initFilterDrawer() {
    var openBtn   = document.getElementById('lwMobileFilterBtn');
    var overlay   = document.getElementById('lwFilterOverlay');
    var drawer    = document.getElementById('lwFilterDrawer');
    var closeBtn  = document.getElementById('lwFilterDrawerClose');
    var applyBtn  = document.getElementById('lwFilterDrawerClose2');
    if (!openBtn || !overlay || !drawer) return;

    function open() {
      // Clear inline visibility:hidden so CSS class can take over
      overlay.style.visibility = '';
      drawer.style.visibility  = '';
      overlay.classList.add('lw-filter-overlay--open');
      drawer.classList.add('lw-filter-drawer--open');
      document.body.style.overflow = 'hidden';
      openBtn.innerHTML = LWIcon('close', 16) + ' Close Filters';
    }
    function close() {
      overlay.classList.remove('lw-filter-overlay--open');
      drawer.classList.remove('lw-filter-drawer--open');
      document.body.style.overflow = '';
      openBtn.innerHTML = LWIcon('settings', 16) + ' Filters';
    }

    openBtn.addEventListener('click', function () {
      drawer.classList.contains('lw-filter-drawer--open') ? close() : open();
    });
    overlay.addEventListener('click', close);
    closeBtn  && closeBtn.addEventListener('click', close);
    applyBtn  && applyBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Responsive: always close on desktop resize
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) close();
    });
  }

  /* ── Filter Section Accordion ─────────────────────────────── */
  function initFilterAccordion() {
    document.querySelectorAll('.lw-filter-sec-hd').forEach(function (hd) {
      hd.addEventListener('click', function () {
        var body = hd.nextElementSibling;
        var isCollapsed = hd.classList.contains('lw-filter-sec-hd--collapsed');
        hd.classList.toggle('lw-filter-sec-hd--collapsed');
        if (body) body.classList.toggle('lw-filter-body--hidden', !isCollapsed);
      });
    });
  }

  /* ── Filter Checkbox Toggle ───────────────────────────────── */
  function initStaticFilterCheckboxes() {
    document.querySelectorAll('[data-lw-filter-check]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        // If this row has a native Shopify filter link - navigate to it
        var link = el.querySelector('.lw-filter-opt-link[href]');
        if (link && link.getAttribute('href') && link.getAttribute('href') !== '#') {
          // Don't double-navigate if user clicked the link itself
          if (e.target !== link && !link.contains(e.target)) {
            e.preventDefault();
            window.location.href = link.getAttribute('href');
          }
          return;
        }
        // Demo/static fallback - visual toggle only
        var box = el.querySelector('.lw-fo-box');
        var isActive = el.classList.toggle('lw-filter-opt--active');
        if (box) {
          box.innerHTML = isActive ? LWIcon('check', 14) : '';
          box.classList.toggle('lw-fo-box--checked', isActive);
        }
      });
    });
  }

  /* ── Swatch Toggle ───────────────────────────────────────── */
  function initSwatches() {
    document.querySelectorAll('.lw-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        sw.classList.toggle('lw-swatch--active');
      });
    });
  }

  /* ── Sort Select ─────────────────────────────────────────── */
  function initSortSelect() {
    var select = document.getElementById('lwSortSelect');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── Price Form ──────────────────────────────────────────── */
  function initPriceForm() {
    var form = document.getElementById('lwPriceForm');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var minInput = form.querySelector('[name="filter.v.price.gte"]');
      var maxInput = form.querySelector('[name="filter.v.price.lte"]');
      var url = new URL(window.location.href);
      // preserve other filters
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      if (minInput && minInput.value) url.searchParams.set('filter.v.price.gte', minInput.value);
      if (maxInput && maxInput.value) url.searchParams.set('filter.v.price.lte', maxInput.value);
      window.location.href = url.toString();
    });
  }

  /* ── Clear All Filters ───────────────────────────────────── */
  function initClearAll() {
    document.querySelectorAll('[data-lw-clear-filters]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = window.location.pathname;
      });
    });
  }

  /* ── Wishlist Toggle ─────────────────────────────────────── */
  function initWishlist() {
    document.querySelectorAll('.lw-product-card__wish').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isWished = btn.classList.contains('lw-wished');
        btn.classList.toggle('lw-wished', !isWished);
        btn.innerHTML = isWished ? LWIcon('heart-outline', 18) : LWIcon('heart', 18);
        btn.style.color = isWished ? '' : '#C4952A';
      });
    });
  }

  /* ── Recently Viewed ─────────────────────────────────────── */
  var RV_KEY = 'loywis_rv';
  var RV_MAX = 20;

  window.lwRecordRecentlyViewed = function (handle) {
    try {
      var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
      localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (_) {}
  };

  function initRecentlyViewed() {
    var container = document.getElementById('lwRecentlyViewed');
    if (!container) return;

    var maxItems = parseInt(container.dataset.max || '4', 10);
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (_) {}
    handles = handles.slice(0, maxItems);

    if (handles.length === 0) {
      var sec0 = container.closest('.lw-rv-section');
      if (sec0) sec0.classList.add('lw-rv--empty');
      return;
    }

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) {
        var sec1 = container.closest('.lw-rv-section');
        if (sec1) sec1.classList.add('lw-rv--empty');
        return;
      }

      container.innerHTML = valid.map(function (p) {
        var price = (p.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
        var img   = p.images && p.images[0];
        var imgHtml = img
          ? '<img class="lw-product-card__img" src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" style="width:100%;display:block;">'
          : '<div class="lw-product-card__img" style="display:flex;align-items:center;justify-content:center;background:#faf7f2;font-size:36px;color:#C4952A;">' + LWIcon('gem', 36) + '</div>';
        return [
          '<a href="/products/' + p.handle + '" class="lw-product-card lw-rv__item" style="display:block;text-decoration:none;color:inherit;">',
          imgHtml,
          '<div style="padding:8px 10px 10px;">',
          '<div class="lw-rv__name" style="font-size:13px;color:#1a1a1a;line-height:1.35;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;">', esc(p.title), '</div>',
          '<div class="lw-rv__price" style="font-size:14px;font-weight:700;color:#1a1a1a;margin-top:4px;">', price, '</div>',
          '</div></a>'
        ].join('');
      }).join('');
    });
  }

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Quickbar active state ───────────────────────────────── */
  function initQuickbar() {
    var currentPath = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.lw-quickbar__link[data-path]').forEach(function (link) {
      if ((link.dataset.path || '').replace(/\/$/, '') === currentPath) {
        link.classList.add('lw-quickbar__link--active');
      }
    });
  }

  /* ── WA Popup ────────────────────────────────────────────── */
  function initWaPopup() {
    var popup   = document.getElementById('lwWaPopup');
    var floatBtn = document.getElementById('lwWaFloatBtn');
    if (!popup || !floatBtn) return;
    setTimeout(function () {
      popup.style.opacity = '0';
      popup.style.transition = 'opacity .4s';
    }, 5000);
    floatBtn.addEventListener('mouseenter', function () { popup.style.opacity = '1'; });
    floatBtn.addEventListener('mouseleave', function () { popup.style.opacity = '0'; });
    floatBtn.addEventListener('click', function () {
      popup.style.display = popup.style.display === 'none' ? '' : '';
    });
  }

  /* ── Load More (AJAX append) ─────────────────────────────── */
  function initLoadMore() {
    var btn = document.getElementById('lwLoadMoreBtn');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = btn.getAttribute('href');
      if (!url) return;

      var originalHtml = btn.innerHTML;
      btn.innerHTML = LWIcon('refresh', 16) + ' Loading…';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '.6';

      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          // Grab the product cards from the fetched page grid
          var remoteGrid = doc.getElementById('lwProductsGrid');
          var currentGrid = document.getElementById('lwProductsGrid');
          if (remoteGrid && currentGrid) {
            // Append only product cards - promo cards / WA bands are re-injected
            // on every paginated page and would otherwise duplicate.
            remoteGrid.querySelectorAll('.lw-product-card').forEach(function (card) {
              currentGrid.appendChild(card.cloneNode(true));
            });
          }

          // Update count label
          var remoteCount = doc.querySelector('.lw-results-count strong');
          var localCount = document.querySelector('.lw-results-count strong');
          if (remoteCount && localCount) localCount.textContent = localCount.textContent; // keep existing

          // Update Load More button - point to new next page, or hide
          var remoteBtn = doc.getElementById('lwLoadMoreBtn');
          var wrap = btn.closest('.lw-load-more-wrap');
          if (remoteBtn) {
            btn.setAttribute('href', remoteBtn.getAttribute('href'));
            btn.innerHTML = remoteBtn.innerHTML;
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
          } else {
            // No more pages - remove the button wrapper
            if (wrap) wrap.remove();
          }

          // Wishlist hearts are handled globally via delegation in loywis-theme.js
          // (no per-card re-binding needed here).

          // Re-apply any active filters so appended cards obey the filter
          // (prevents other categories from showing after Load More).
          if (window.lwReapplyFilters) window.lwReapplyFilters();
        })
        .catch(function () {
          btn.innerHTML = originalHtml;
          btn.style.pointerEvents = '';
          btn.style.opacity = '';
        });
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    initViewToggle();
    initFilterDrawer();
    initFilterAccordion();
    initStaticFilterCheckboxes();
    initSwatches();
    initSortSelect();
    initPriceForm();
    initClearAll();
    initRecentlyViewed();
    initQuickbar();
    initWaPopup();
    initLoadMore();
    initClientFilters();
    // Wishlist is delegated globally in loywis-theme.js (works on every page + AJAX)
  }

  /* ============================================================
     CLIENT-SIDE FILTERS - works WITHOUT Search & Discovery app
     Filters .lw-product-card DOM elements by data attributes.
     ============================================================ */
  function initClientFilters() {
    // If Shopify "Search & Discovery" native filters are rendered, they handle
    // filtering server-side (correct counts + full results). Skip the JS filter.
    if (document.querySelector('[data-lw-native-filters]')) return;

    var grid = document.querySelector('.lw-products-grid');
    if (!grid) return;

    var cards = function () { return Array.from(grid.querySelectorAll('.lw-product-card')); };
    var allCards = cards();
    if (!allCards.length) return;

    // Active filter state
    var state = {
      category:     new Set(),  // product types (case-sensitive)
      tag:          new Set(),  // tags (lowercased)
      vendor:       new Set(),  // vendors
      availability: new Set(),  // 'in_stock'
      priceMin: null,
      priceMax: null
    };

    /* ---- Apply filters: hide cards that don't match ---- */
    function applyFilters() {
      var visible = 0;
      cards().forEach(function (card) {
        var type     = card.dataset.productType || '';
        var tagsStr  = (card.dataset.productTags || '').toLowerCase();
        var tagArr   = tagsStr ? tagsStr.split('|') : [];
        var vendor   = card.dataset.productVendor || '';
        var price    = parseFloat(card.dataset.productPrice || '0');
        var avail    = card.dataset.productAvailable === '1';

        var pass = true;

        if (state.category.size > 0 && !state.category.has(type)) pass = false;
        if (pass && state.vendor.size > 0 && !state.vendor.has(vendor)) pass = false;
        if (pass && state.tag.size > 0) {
          var hasAnyTag = false;
          state.tag.forEach(function (t) { if (tagArr.indexOf(t) !== -1) hasAnyTag = true; });
          if (!hasAnyTag) pass = false;
        }
        if (pass && state.availability.has('in_stock') && !avail) pass = false;
        if (pass && state.priceMin !== null && price < state.priceMin) pass = false;
        if (pass && state.priceMax !== null && price > state.priceMax) pass = false;

        card.style.display = pass ? '' : 'none';
        if (pass) visible++;
      });

      updateResultsCount(visible);
      updateFilterCounts();
      updateActiveChips();
    }

    /* ---- Update "N products" counter on page ---- */
    function updateResultsCount(n) {
      document.querySelectorAll('[data-lw-results-count], .lw-results-count, .lw-results-count-m').forEach(function (el) {
        el.textContent = n + ' product' + (n === 1 ? '' : 's');
      });
    }

    /* ---- Refresh counts shown next to each filter option (cards that would match if THIS filter were toggled) ---- */
    function updateFilterCounts() {
      document.querySelectorAll('[data-lw-cf-count]').forEach(function (el) {
        var key = el.dataset.lwCfCount;  // e.g., "category:mangalsutra"
        var parts = key.split(':');
        var type  = parts[0];
        var val   = parts[1];

        var count = 0;
        cards().forEach(function (card) {
          var match = false;
          if (type === 'category') {
            match = (card.dataset.productType || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') === val;
          } else if (type === 'tag') {
            var tagsStr = (card.dataset.productTags || '').toLowerCase();
            var tagArr  = tagsStr.split('|').map(function (t) { return t.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); });
            match = tagArr.indexOf(val) !== -1;
          } else if (type === 'vendor') {
            match = (card.dataset.productVendor || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') === val;
          } else if (type === 'availability') {
            match = card.dataset.productAvailable === '1';
          }
          if (match) count++;
        });
        el.textContent = '(' + count + ')';
      });
    }

    /* ---- Sync active filter visuals (checkbox state) ---- */
    function updateActiveChips() {
      document.querySelectorAll('[data-lw-cf-type][data-lw-cf-value]').forEach(function (el) {
        var type  = el.dataset.lwCfType;
        var value = el.dataset.lwCfValue;
        var isActive = false;
        if (type === 'tag') {
          isActive = state.tag.has(value.toLowerCase());
        } else if (state[type]) {
          isActive = state[type].has(value);
        }
        el.classList.toggle('lw-filter-opt--active', isActive);
        var box = el.querySelector('.lw-fo-box');
        if (box) {
          box.innerHTML = isActive ? LWIcon('check', 14) : '';
          box.classList.toggle('lw-fo-box--checked', isActive);
        }
      });
    }

    /* ---- Bind click events on all filter options ---- */
    document.querySelectorAll('[data-lw-cf-type][data-lw-cf-value]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var type  = el.dataset.lwCfType;
        var value = el.dataset.lwCfValue;
        var setKey = type;
        var lookup = type === 'tag' ? value.toLowerCase() : value;
        if (!state[setKey]) return;
        if (state[setKey].has(lookup)) state[setKey].delete(lookup);
        else state[setKey].add(lookup);
        applyFilters();
        syncUrlHash();
      });
    });

    /* ---- Price presets ---- */
    document.querySelectorAll('[data-lw-cf-price-preset]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var range = btn.dataset.lwCfPricePreset.split(',');
        state.priceMin = parseInt(range[0], 10);
        state.priceMax = parseInt(range[1], 10);
        var minIn = document.querySelector('[data-lw-cf-price-min]');
        var maxIn = document.querySelector('[data-lw-cf-price-max]');
        if (minIn) minIn.value = state.priceMin;
        if (maxIn) maxIn.value = state.priceMax === 99999 ? '' : state.priceMax;
        document.querySelectorAll('[data-lw-cf-price-preset]').forEach(function (b) { b.classList.remove('lw-price-preset--active'); });
        btn.classList.add('lw-price-preset--active');
        applyFilters();
        syncUrlHash();
      });
    });

    /* ---- Price form submit ---- */
    var priceForm = document.querySelector('[data-lw-cf-price-form]');
    if (priceForm) {
      priceForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var minIn = priceForm.querySelector('[data-lw-cf-price-min]');
        var maxIn = priceForm.querySelector('[data-lw-cf-price-max]');
        state.priceMin = minIn && minIn.value ? parseInt(minIn.value, 10) : null;
        state.priceMax = maxIn && maxIn.value ? parseInt(maxIn.value, 10) : null;
        document.querySelectorAll('[data-lw-cf-price-preset]').forEach(function (b) { b.classList.remove('lw-price-preset--active'); });
        applyFilters();
        syncUrlHash();
      });
    }

    /* ---- Clear all filters ---- */
    document.querySelectorAll('[data-lw-clear-filters], [data-lw-clear-all], .lw-active-chip--clear').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        state.category.clear();
        state.tag.clear();
        state.vendor.clear();
        state.availability.clear();
        state.priceMin = null;
        state.priceMax = null;
        var minIn = document.querySelector('[data-lw-cf-price-min]');
        var maxIn = document.querySelector('[data-lw-cf-price-max]');
        if (minIn) minIn.value = '';
        if (maxIn) maxIn.value = '';
        document.querySelectorAll('[data-lw-cf-price-preset]').forEach(function (b) { b.classList.remove('lw-price-preset--active'); });
        applyFilters();
        location.hash = '';
      });
    });

    /* ---- URL hash sync: ?#category=Mangalsutra,Bangles&tag=gold&price=100-500 ---- */
    function syncUrlHash() {
      var parts = [];
      if (state.category.size) parts.push('category=' + Array.from(state.category).map(encodeURIComponent).join(','));
      if (state.tag.size)      parts.push('tag=' + Array.from(state.tag).map(encodeURIComponent).join(','));
      if (state.vendor.size)   parts.push('vendor=' + Array.from(state.vendor).map(encodeURIComponent).join(','));
      if (state.availability.size) parts.push('avail=in_stock');
      if (state.priceMin !== null || state.priceMax !== null) {
        parts.push('price=' + (state.priceMin || 0) + '-' + (state.priceMax || ''));
      }
      var hash = parts.length ? '#' + parts.join('&') : '';
      if (hash !== location.hash) history.replaceState(null, '', location.pathname + location.search + hash);
    }

    function restoreFromHash() {
      var h = location.hash.replace(/^#/, '');
      if (!h) return;
      h.split('&').forEach(function (pair) {
        var kv = pair.split('=');
        var k = kv[0]; var v = decodeURIComponent(kv[1] || '');
        if (!v) return;
        if (k === 'category') v.split(',').forEach(function (x) { state.category.add(decodeURIComponent(x)); });
        else if (k === 'tag') v.split(',').forEach(function (x) { state.tag.add(decodeURIComponent(x).toLowerCase()); });
        else if (k === 'vendor') v.split(',').forEach(function (x) { state.vendor.add(decodeURIComponent(x)); });
        else if (k === 'avail') state.availability.add(v);
        else if (k === 'price') {
          var rg = v.split('-');
          state.priceMin = rg[0] ? parseInt(rg[0], 10) : null;
          state.priceMax = rg[1] ? parseInt(rg[1], 10) : null;
          var minIn = document.querySelector('[data-lw-cf-price-min]');
          var maxIn = document.querySelector('[data-lw-cf-price-max]');
          if (minIn) minIn.value = state.priceMin || '';
          if (maxIn) maxIn.value = state.priceMax || '';
        }
      });
    }

    // Expose so Load-More (separate scope) can re-apply active filters to
    // any newly appended product cards.
    window.lwReapplyFilters = applyFilters;

    // Initial render
    restoreFromHash();
    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* ============================================================
   COLLECTION LIST PAGE - Tab Filtering + Sort
   ============================================================ */
(function () {
  'use strict';

  function initCollectionListTabs() {
    var tabs = document.querySelectorAll('[data-lw-coll-tab]');
    var grid = document.querySelector('[data-lw-coll-grid]');
    if (!tabs.length || !grid) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('lw-coll-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('lw-coll-tab--active');
        tab.setAttribute('aria-selected', 'true');

        var filter = tab.getAttribute('data-filter');
        var cards  = grid.querySelectorAll('.lw-coll-card');

        cards.forEach(function (card) {
          if (filter === 'all') {
            card.classList.remove('lw-coll-card--hidden');
            return;
          }
          var handle = (card.getAttribute('data-handle') || '').toLowerCase();
          var title  = (card.getAttribute('data-title')  || '').toLowerCase();
          var match  = handle.indexOf(filter) !== -1 || title.indexOf(filter) !== -1;
          card.classList.toggle('lw-coll-card--hidden', !match);
        });
      });
    });
  }

  function initCollectionListSort() {
    var select = document.querySelector('[data-lw-coll-sort]');
    var grid   = document.querySelector('[data-lw-coll-grid]');
    if (!select || !grid) return;

    select.addEventListener('change', function () {
      var value = select.value;
      var cards = Array.from(grid.querySelectorAll('.lw-coll-card'));

      cards.sort(function (a, b) {
        if (value === 'az') {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        }
        if (value === 'za') {
          return (b.getAttribute('data-title') || '').localeCompare(a.getAttribute('data-title') || '');
        }
        if (value === 'count_desc') {
          return parseInt(b.getAttribute('data-count') || '0', 10) - parseInt(a.getAttribute('data-count') || '0', 10);
        }
        return 0;
      });

      cards.forEach(function (card) { grid.appendChild(card); });
    });
  }

  function init() {
    initCollectionListTabs();
    initCollectionListSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
